import React from 'react'
const SeccionCards = (props) => {
    return <div className={`p-col-12 ${props.extra?`${props.extra}`:""} `}><div className="p-grid">
        {props.children}

        
    </div></div>
}
export default SeccionCards;
